<template>
  <div
    v-if="!pwaActive || isDesktop"
    class="contact-form"
  >
    <IoOverlay
      v-if="showModal && (!pwaActive || isDesktop)"
      @close="close()"
    >
      <BaseCard :title="$text('other', 'title', 'Haben Sie Fragen?')">
        <template #content>
          <div class="flex flex-col flex-wrap gap-4">
            <p>{{ $text('other', 'text', 'Senden Sie ganz einfach eine Nachricht an unseren Kundenservice und unsere Mitarbeiter helfen Ihnen so schnell wie möglich!') }}</p>
            <div class="contact-form--group">
              <div class="col">
                <BaseInput
                  v-model="form.title"
                  :label="`${$text('other', 'label.title', 'Titel')}*`"
                  :error="errors.title"
                  outlined
                  rounded
                />
              </div>
              <div
                v-if="categories.length"
                class="col-6"
              >
                <BaseSelect
                  v-model="form.category"
                  :items="categories"
                  :error="errors.category"
                  label="Kategorie*"
                  outlined
                  rounded
                />
              </div>
            </div>
            <BaseTextarea
              v-model="form.message"
              :label="`${$text('other', 'label.message', 'Ihre Nachricht')}*`"
              :error="errors.message"
              outlined
              rounded
            />
            <BaseButtonV2 @click="submit()">
              Nachricht senden
            </BaseButtonV2>
          </div>
        </template>
      </BaseCard>
    </IoOverlay>
    <BaseButtonV2
      class="contact-form--toggle"
      @click="showModal = !showModal"
    >
      <span
        v-if="showModal"
        :key="showModal"
      ><i class="fas fa-xmark" /></span>
      <span
        v-else
        :key="showModal"
      ><i class="fas fa-paper-plane" /></span>
    </BaseButtonV2>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia';

import { useCenterPwaStore } from '@/apps/center/stores/pwa';

export default {
  name: 'ContactForm',
  props: {
    action: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      default: '',
    },
    categories: {
      type: Array,
      default: () => [
        {
          label: 'Übersicht/Dashboard',
          value: 'dashboard',
        },
        {
          label: 'Profil',
          value: 'profile',
        },
        {
          label: 'Energie',
          value: 'energy',
        },
        {
          label: 'Vertrag',
          value: 'contract',
        },
        {
          label: 'Rechnung',
          value: 'bill',
        },
        {
          label: 'Bericht',
          value: 'report',
        },
        {
          label: 'Sonstige',
          value: 'other',
        },
      ],
    },
  },
  setup() {
    const pwaStore = useCenterPwaStore();
    const { isActive: pwaActive, isDesktop } = storeToRefs(pwaStore);

    return {
      pwaActive,
      isDesktop,
    };
  },
  data() {
    return {
      showModal: false,
      errors: {},
      form: {
        title: '',
        message: '',
        category: this.category,
      },
    };
  },
  watch: {
    showModal(value) {
      this.IOH.bodyScroll(value);
    },
    form: {
      handler() {
        this.errors = {};
      },
      deep: true,
    },
  },
  methods: {
    submit() {
      axios.post(this.action, this.form)
        .then((response) => {
          this.showModal = false;
          this.clearForm();
          this.close();
          GlobalEvents.fire('alert', [{ message: response.data.messages[0].message, type: 'success' }]);
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          } else {
            this.close();
          }
          GlobalEvents.fire('alert', [{ message: error.response.data.message, type: 'error' }]);
        });
    },
    close() {
      this.showModal = false;
    },
    clearForm() {
      this.form.title = '';
      this.form.message = '';
      this.form.category = this.category;
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  position: absolute;
  bottom: 6.5rem;
  right: 6.5rem;
  width: calc(50vw - 6.5rem);
  border-radius: 1rem 1rem 0 1rem;
  transition: all 0.3s ease-in-out;

  @media (max-width: 768px) {
    width: calc(100vw - 13rem);
  }

  @media (max-width: 480px) {
    width: calc(100vw - 2rem);
    right: 1rem;
    bottom: 7.5rem;
    border-radius: 1rem;
  }
}

.contact-form {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  z-index: 100;

  &--group {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    > * {
      flex: 1;
    }
  }

  &--toggle {
    position: relative;
    z-index: 1002;

    span,
    svg {
      width: 2.25rem;
      height: 2.25rem;
    }
  }
}
</style>
